<template>
    <v-card color :loading="cardLoading">
        <v-card-title>{{ $t("ecrCodes.uploadFile") }}</v-card-title>

        <v-card-text>
            <v-file-input v-model="file" chips accept=".xml" :label="$t('ecrCodes.uploadFileInputText')" show-size></v-file-input>
        </v-card-text>

        <v-card-actions>
            <div class="flex-grow-1" />

            <v-btn color="success" @click="onSaveClick" :disabled="uploadButtonDisabled">
                <v-icon left>fas fa-save</v-icon>
                {{ $t("common.upload") }}
            </v-btn>

            <v-btn color="error" @click="onCalcelClick" :disabled="cancelButtonDisabled">
                <v-icon left>fas fa-times</v-icon>
                {{ $t("common.cancel") }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
// Vuex
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import * as a_ecr from "@/store/modules/FitnessStatisticsModule/actions";
import * as am from "@/store/modules/AlertModule/mutations";
import { mapActions, mapMutations } from "vuex";

export default {
    components: {},
    data() {
        return {
            cardLoading: false,
            file: null,
        };
    },
    computed: {
        uploadButtonDisabled() {
            return this.cardLoading || this.file == null;
        },

        cancelButtonDisabled() {
            return this.cardLoading;
        },
    },
    methods: {
        ...mapActions([a_ecr.UPLOAD_ECR_FILE, a_ecr.GET_AVAILABLE_ECR_CODES, a_ecr.GET_DISTINCT_SENSORS_DATA, a_ecr.GET_ECR_FILE_INFORMATIONS]),
        ...mapMutations([am.ADD_ALERT]),

        async onSaveClick() {
            this.cardLoading = true;
            const res = await this[a_ecr.UPLOAD_ECR_FILE](this.file);

            if (res.status == 200 && res.data.Response == 0) {
                await this[a_ecr.GET_AVAILABLE_ECR_CODES]();
                await this[a_ecr.GET_DISTINCT_SENSORS_DATA]();
                await this[a_ecr.GET_ECR_FILE_INFORMATIONS]();
            } else this[am.ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("ecrCodes.errorUploadingFile"), null));

            this.file = null;
            this.$emit("close");
            this.cardLoading = false;
        },

        onCalcelClick() {
            this.file = null;
            this.$emit("close");
        },
    },
};
</script>
